import React from 'react';
import { HelpMenu } from '@im/ui-lib/HelpMenu';
import { useHelpNavItems } from '../../app/nav/useHelpNavItems';

// eslint-disable-next-line import/no-default-export
export default function IngramHelpMenu() {
  const helpNavItems = useHelpNavItems();
  return (
    <>
      {helpNavItems && helpNavItems.length > 0 && (
        <HelpMenu
          data-testid="help-menu-fab"
          height={48}
          key="help-menu-items"
          left={8}
          marginTop={80}
          navItems={helpNavItems}
          width={48}
        />
      )}
    </>
  );
}
